import { colors } from '@insurancemenu/imenu-components-lib';
import { Delete, Edit, Mail } from '@insurancemenu/imenu-components-lib/dist/icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EmployerDelegate } from 'store/modules/group/ui-stores/employerDelegate';
import { InviteEmployersDelegate } from 'store/modules/group/ui-stores/inviteEmployersDelegate';
import {
  EMPLOYER_BLOCK_TEST_ID,
  EDIT_EMPLOYER_BTN_TEST_ID,
  REINVITE_EMPLOYER_BTN_TEST_ID,
  REMOVE_EMPLOYER_BTN_TEST_ID,
} from 'components/common/group/constants';
import {
  ActionBtnStyled,
  EditBtnStyled,
  EmployerBlockKeyStyled,
  EmployerBlockStyled,
  EmployerBlockValueStyled,
  EmployerWrapperStyled,
  GroupAdminTagStyled,
  ReinviteButtonStyled,
  StatusValueStyled,
} from './styles';
import { EditEmployerForm } from '../EditEmployerForm';

interface Props {
  inviteEmployersDelegate: InviteEmployersDelegate;
  employerDelegate: EmployerDelegate;
  isGroupAdmin?: boolean;
}

const EmployerBlock: React.FC<Props> = observer(
  ({ inviteEmployersDelegate, employerDelegate, isGroupAdmin = false }) => {
    const { employer } = employerDelegate;
    const employerId = employer.id;

    if (employerDelegate.editModeOn) {
      return <EditEmployerForm employerDelegate={employerDelegate} />;
    }

    async function removeEmployer(): Promise<void> {
      await inviteEmployersDelegate.removeEmployer(employerId);
    }

    return (
      <EmployerWrapperStyled $isGroupAdmin={isGroupAdmin} data-test-id={EMPLOYER_BLOCK_TEST_ID}>
        <EmployerBlockStyled>
          <div>
            <EmployerBlockKeyStyled>Name</EmployerBlockKeyStyled>
            <EmployerBlockValueStyled>{employerDelegate.employerFullName}</EmployerBlockValueStyled>
          </div>
          <div>
            <EmployerBlockKeyStyled>Email</EmployerBlockKeyStyled>
            <EmployerBlockValueStyled>{employer.email}</EmployerBlockValueStyled>
          </div>
          <div>
            <EmployerBlockKeyStyled>Phone</EmployerBlockKeyStyled>
            <EmployerBlockValueStyled>{employer.telephone}</EmployerBlockValueStyled>
          </div>
          <div>
            <EmployerBlockKeyStyled>Title</EmployerBlockKeyStyled>
            <EmployerBlockValueStyled>{employer.title}</EmployerBlockValueStyled>
          </div>
          <div>
            <EmployerBlockKeyStyled>
              Status: <StatusValueStyled>{employer.status}</StatusValueStyled>
            </EmployerBlockKeyStyled>
            <ReinviteButtonStyled
              onClick={employerDelegate.reinviteEmployer}
              type="text"
              color="primary"
              leftIconProp={<Mail />}
              uppercase
              data-test-id={REINVITE_EMPLOYER_BTN_TEST_ID}
            >
              Reinvite
            </ReinviteButtonStyled>
          </div>
        </EmployerBlockStyled>

        {isGroupAdmin ? (
          <GroupAdminTagStyled>Group Admin</GroupAdminTagStyled>
        ) : (
          <div>
            <EditBtnStyled
              onClick={(): void => employerDelegate.setEditModeOn(true)}
              type="text"
              color="primary"
              leftIconProp={<Edit />}
              data-test-id={EDIT_EMPLOYER_BTN_TEST_ID}
            >
              Edit
            </EditBtnStyled>
            <ActionBtnStyled
              type="text"
              color="custom"
              customColor={colors.red[600]}
              leftIconProp={<Delete />}
              onClick={removeEmployer}
              data-test-id={REMOVE_EMPLOYER_BTN_TEST_ID}
            >
              Remove
            </ActionBtnStyled>
          </div>
        )}
      </EmployerWrapperStyled>
    );
  },
);

export default EmployerBlock;
